import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import { Help } from '../../../../common/Help'
import { Header } from './Header'

export const HelpHeader: React.FC<{
  label: string
  helpText: string
  style?: { [key: string]: number }
  link?: string
}> = (props) => {
  const helpElement = () => (
    <Help
      css={css`
        color: ${colors.gray90};
        vertical-align: middle;
      `}
    >
      {props.helpText}
    </Help>
  )
  return (
    <Header style={props.style}>
      <span
        css={css`
          display: inline-flex;
          align-items: center;
          column-gap: 4px;
        `}
      >
        <span
          className="u-mr10"
          css={css`
            text-align: center;
            white-space: pre-wrap;
            line-height: 1.25;
          `}
        >
          {props.label}
        </span>
        {props.link ? (
          <a
            className="help-icon"
            href={props.link}
            target="_blank"
            rel="noopener noreferrer"
            css={css`
              color: inherit;
            `}
          >
            {helpElement()}
          </a>
        ) : (
          helpElement()
        )}
      </span>
    </Header>
  )
}
